import { useState } from "react";

import ModalNav from "../../../Components/Modal/ModalNav";
import ModalTab from "../../../Components/Modal/ModalTab";
import UlSubjectList from "../List/UlSubjectList";
import FlSubjectList from "../List/FlSubjectList";
import Modal from "../../../Components/Modal/Modal";

export default function CustomersModal({ title, isOpen, setOpen, onClick, children, ulSubject,onSave }) {
  const [selected, setSelected] = useState("fl");

  return (
    <Modal title={title} isOpen={isOpen} setOpen={setOpen} onSave={onSave}>
      <ModalNav>
        <ModalTab
          text="Физ лицо"
          onClick={() => setSelected("fl")}
          isActive={selected === "fl"}
        />
        <ModalTab text="Юр лицо" onClick={() => setSelected("ul")} isActive={selected === "ul" ? true : false} />
      </ModalNav>
      {selected === "fl" && <FlSubjectList onClick={onClick} /> }
      {selected === "ul" && <UlSubjectList ulSubject={ulSubject} onAdd={onClick}/> }
      {children}
    </Modal>
  );
}